module.exports = __webpack_public_path__ + "fonts/HMpangram-ExtraBold.fd903152.ttf";